import { render, staticRenderFns } from "./CategoryProductsModal.vue?vue&type=template&id=0bbdaab0"
import script from "./CategoryProductsModal.vue?vue&type=script&lang=js"
export * from "./CategoryProductsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports